export default __webpack_public_path__ + "static/media/control.22be6a49.svg";